import { pickupKindTypes } from '../../../enums/stopTypes';

export const INCLUDE_EXCLUDE_CRITERIA = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
};

export const INCLUDE_EXCLUDE_OPTIONS = [
  {
    label: 'Include',
    value: INCLUDE_EXCLUDE_CRITERIA.INCLUDE,
  },
  {
    label: 'Exclude',
    value: INCLUDE_EXCLUDE_CRITERIA.EXCLUDE,
  },
];

export const OPERATORS = [
  {
    label: '>',
    value: '>',
  },
  {
    label: '>=',
    value: '>=',
  },
  {
    label: '=',
    value: '=',
  },
  {
    label: '<',
    value: '<',
  },
  {
    label: '<=',
    value: '<=',
  },
];

export const CRITERIA = {
  CADS: 'cads',
  DELIVERY_DAY: 'deliveryDay',
  ETA: 'eta',
  EXCEPTION: 'exception',
  HUB_LAST_SCANNED_IN: 'hubLastScannedIn',
  HUB_SCAN_DATE_TIME: 'hubScanDateTime',
  LOADED: 'loaded',
  PICKUP_KIND: 'pickupKind',
  OPPORTUNITY_TIME: 'opportunityTime',
  PARCEL_AGE: 'parcelAge',
  PARCELS_NO_OF: 'parcelsNoOf',
  PERISHABLE: 'perishable',
  POSTCODE: 'postcode',
  PRECISE: 'precise',
  PREMIUMS: 'premiums',
  PRIORITY: 'priority',
  PROPERTY_TYPE: 'propertyType',
  REQUEST: 'request',
  SMALLS: 'smalls',
  STOP_TIME: 'stopTime',
  STOP_TYPE: 'stopType',
  MANIFEST_LOCATION: 'manifestLocation',
};

export const CRITERIA_OPTIONS = [
  {
    label: 'CADs',
    value: CRITERIA.CADS,
  },
  {
    label: 'Delivery Day',
    value: CRITERIA.DELIVERY_DAY,
  },
  {
    label: 'ETA',
    value: CRITERIA.ETA,
  },
  {
    label: 'Exception',
    value: CRITERIA.EXCEPTION,
  },
  {
    label: 'Hub Last Scanned In',
    value: CRITERIA.HUB_LAST_SCANNED_IN,
  },
  {
    label: 'Hub Scan date/time',
    value: CRITERIA.HUB_SCAN_DATE_TIME,
  },
  {
    label: 'Loaded',
    value: CRITERIA.LOADED,
  },
  {
    label: 'Opportunity Time',
    value: CRITERIA.OPPORTUNITY_TIME,
  },
  {
    label: 'Parcel Age',
    value: CRITERIA.PARCEL_AGE,
  },
  {
    label: 'Parcels (no. of)',
    value: CRITERIA.PARCELS_NO_OF,
  },
  {
    label: 'Perishable',
    value: CRITERIA.PERISHABLE,
  },
  {
    label: 'Postcode',
    value: CRITERIA.POSTCODE,
  },
  {
    label: 'Precise',
    value: CRITERIA.PRECISE,
  },
  {
    label: 'Premiums',
    value: CRITERIA.PREMIUMS,
  },
  {
    label: 'Priority',
    value: CRITERIA.PRIORITY,
  },
  {
    label: 'Property Type',
    value: CRITERIA.PROPERTY_TYPE,
  },
  {
    label: 'Request',
    value: CRITERIA.REQUEST,
  },
  {
    label: 'Smalls',
    value: CRITERIA.SMALLS,
  },
  {
    label: 'Stop Time',
    value: CRITERIA.STOP_TIME,
  },
  {
    label: 'Stop Type',
    value: CRITERIA.STOP_TYPE,
  },
  {
    label: 'Manifest Location',
    value: CRITERIA.MANIFEST_LOCATION,
  },
  {
    label: 'Pickup Kind',
    value: CRITERIA.PICKUP_KIND,
  },
];

export const ALL_PART_NONE_OPTIONS_VALUES = {
  ALL: 'all',
  PART: 'part',
  NONE: 'none',
};

export const ALL_PART_NONE_OPTIONS = [
  {
    value: ALL_PART_NONE_OPTIONS_VALUES.ALL,
    label: 'All',
  },
  {
    value: ALL_PART_NONE_OPTIONS_VALUES.PART,
    label: 'Part',
  },
  {
    value: ALL_PART_NONE_OPTIONS_VALUES.NONE,
    label: 'None',
  },
];

export const PICKUP_KIND_OPTIONS = [
  {
    value: pickupKindTypes.shop,
    label: 'Shop',
  },
  {
    value: pickupKindTypes.locker,
    label: 'Locker',
  },
];

export const YES_NO_OPTIONS_VALUES = {
  YES: 'yes',
  NO: 'no',
};

export const YES_NO_OPTIONS = [
  {
    value: YES_NO_OPTIONS_VALUES.YES,
    label: 'Yes',
  },
  {
    value: YES_NO_OPTIONS_VALUES.NO,
    label: 'No',
  },
];

export const DELIVERY_DAY_OPTIONS_VALUES = {
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
  BOTH: 'both',
  NONE: 'none',
};

export const DELIVERY_DAY_OPTIONS = [
  {
    value: DELIVERY_DAY_OPTIONS_VALUES.SATURDAY,
    label: 'Saturday',
  },
  {
    value: DELIVERY_DAY_OPTIONS_VALUES.SUNDAY,
    label: 'Sunday',
  },
  {
    value: DELIVERY_DAY_OPTIONS_VALUES.BOTH,
    label: 'Both',
  },
  {
    value: DELIVERY_DAY_OPTIONS_VALUES.NONE,
    label: 'None',
  },
];

export const PROPERTY_TYPE_OPTIONS_VALUES = {
  B2B: 'b2b',
  B2C: 'b2c',
};

export const PROPERTY_TYPE_OPTIONS = [
  {
    value: PROPERTY_TYPE_OPTIONS_VALUES.B2B,
    label: PROPERTY_TYPE_OPTIONS_VALUES.B2B.toUpperCase(),
  },
  {
    value: PROPERTY_TYPE_OPTIONS_VALUES.B2C,
    label: PROPERTY_TYPE_OPTIONS_VALUES.B2C.toUpperCase(),
  },
];

export const REQUEST_OPTIONS_VALUES = {
  OPEN: 'open',
  NONE: 'none',
};

export const REQUEST_OPTIONS = [
  {
    value: REQUEST_OPTIONS_VALUES.OPEN,
    label: 'Open',
  },
  {
    value: REQUEST_OPTIONS_VALUES.NONE,
    label: 'None',
  },
];

export const CRITERIA_TYPE = {
  DATETIME: 'datetime',
  TIME: 'time',
  SELECT: 'select',
  NUMBER: 'number',
  STRING: 'string',
};

export const EXCEPTION_TYPES_VALUES = {
  POSTCODE: 'postcode',
  SERVICE: 'service',
  DUTY: 'duty',
  RANGE: 'range',
  LEGAL_DUTY: 'legal duty',
};

export const EXCEPTION_TYPES = {
  1: {
    value: EXCEPTION_TYPES_VALUES.POSTCODE,
    label: 'Postcode',
  },
  2: {
    value: EXCEPTION_TYPES_VALUES.SERVICE,
    label: 'Service',
  },
  3: {
    value: EXCEPTION_TYPES_VALUES.DUTY,
    label: 'Duty',
  },
  6: {
    value: EXCEPTION_TYPES_VALUES.RANGE,
    label: 'Range',
  },
  7: {
    value: EXCEPTION_TYPES_VALUES.LEGAL_DUTY,
    label: 'Legal Duty',
  },
};

export const DELIVERY_STOP_TYPES = {
  PRECISE: 'Precise',
  PREMIUM: 'Premium',
  BULK: 'Bulk',
  PERISHABLE: 'Perishable',
  PICKUP: 'Pickup',
  VIP: 'VIP',
  STANDARD: 'STD',
};
